<template>
  <CRow>
    <CCol col="12" md="12">
      <CCard>
        <CCardBody>
         
              <CRow>
                <CCol col="6" md="7">
                  <CCard>
                    <CCardHeader>
                      <p>
                        <img src="img/factory.svg" style="width:20px" />Medicinetype
                      </p>
                    </CCardHeader>

                    <CCardBody>
                      <CDataTable
                        :items="breedItem"
                        :fields="fields"
                        table-filter
                        items-per-page-select
                        :items-per-page="10"
                        pagination
                        clickable-rows
                        hover
                        @row-clicked="rowClicked"
                        caption="Breed"
                      />
                    </CCardBody>
                  </CCard>
                </CCol>

                <CCol col="6" md="5">
                  <CCard>
                    <CCardHeader>
                      <p>
                        <img src="img/factory.svg" style="width:20px" /> Medicinetype Details
                      </p>
                    </CCardHeader>
                    <CCardBody>
                      <CForm>
                        <CInput
                          label="Type"
                          v-model="type"
                          name="type"
                          id="type"
                          required
                          horizontal
                          autocomplete="name"
                        />

                        <CInput
                          label="Name"
                          v-model="name"
                          name="Name"
                          id="Name"
                          required
                          horizontal
                          autocomplete="name"
                        />
                        <CSelect
                          label="Species"
                          horizontal
                          :options="options"
                          placeholder="Please select"
                          name="categories"
                          id="categories"
                          :value.sync="categories"
                        />
                      </CForm>
                    </CCardBody>
                    <CCardFooter>
                      <CButton color="info" style="width:100px" v-if="addButton" @click="addBreed">
                        <CIcon name="cilPencil" />&nbsp;Add
                      </CButton>&nbsp;
                      <CButton
                        color="success"
                        style="width:100px"
                        v-if="saveButton"
                        @click="updateBreed"
                      >
                        <CIcon name="cilCheck" />&nbsp;Save
                      </CButton>&nbsp;
                      <CButton
                        color="danger"
                        style="width:100px"
                        v-if="deleteButton"
                        @click="deleteBreed"
                      >
                        <CIcon name="cilXCircle" />&nbsp;Delete
                      </CButton>&nbsp;
                      <CButton
                        color="success"
                        style="width:100px"
                        v-if="EditsaveButton"
                        @click="addBreed"
                      >
                        <CIcon name="cilCheck" />&nbsp;Save
                      </CButton>
&nbsp;
                      <CButton
                        color="secondary"
                        style="width:100px"
                        v-if="cancelButton"
                        @click="CancelBreed"
                      >
                        <CIcon name="cilWarning" />&nbsp;Cancel
                      </CButton>&nbsp;
                      <CButton color="info" v-if="addnewButton" @click="addBreedplus">
                        <CIcon name="cilPencil" />&nbsp;Add New
                      </CButton>
                    </CCardFooter>
                  </CCard>
                </CCol>
              </CRow>
            
           
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../tables/Table";
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
export default {
  components: { CTableWrapper},
  

  data() {
    return {
      type: null,
      name: "",
      categories: "",
      breedItem: [],
      editBreed: [],
      options: ["", "Cow", "Buffalo"],
      tabs: ["Breed Details", "Tasks"],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      fields: [
        {
          key: "type",
          sortable: true
        },
        {
          key: "name",
          sortable: true
        },
        {
          key: "categories",
          sortable: true
        }
      ],
      
    };
  },
  methods: {
    getmedicinetypeList() {
      APIService.medicinetypeList().then(res => {
        if (res.status == 200) {
          this.breedItem = res.data;

            this.type =  this.breedItem[0].type;
      this.name =this.breedItem[0].name;
      this.categories =this.breedItem[0].categories;
        }
      });
    },
    
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editBreed = item;
      this.type = item.type;
      this.name = item.name;
      this.categories = item.categories;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addBreed() {
      let type = this.type;
      let name = this.name;
      let categories = this.categories;
      let data = {
        type,
        name,
        categories
      };
      APIService.saveMedicinetype(data).then(res => {
        if (res.status == 200) {
          this.type = null;
          this.name = "";
          this.categories = "";
         this.getmedicinetypeList();
            Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addBreedplus() {
      this.type = null;
      this.name = "";
      this.categories = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true)
      return getmedicinetypeList();
    },

    CancelBreed() {
       this.type = null;
      this.name = "";
      this.categories = "";
      this.addButton = true;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = false;
      (this.EditsaveButton = false), this.getmedicinetypeList();
    },
    updateBreed() {
      let id = this.editBreed._id;
      let type = this.type;
      let name = this.name;
      let categories = this.categories;
      let value = {
         type,
        name,
        categories
      };
      let data = { id, value };
      APIService.medicinetypeUpdate(data).then(res => {
        if (res.status == 200) {
         this.type = null;
          this.name = "";
          this.categories = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.getmedicinetypeList();
            Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteBreed() {

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})

    },
delete(){
   let id = this.editBreed._id;
      let data = { id };
      APIService.medicinetypeDelete(data).then(res => {
        if (res.status == 200) {
          this.type = null;
          this.name = "";
          this.categories = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getmedicinetypeList();
        }
      });
    }
  },
  created() {
    this.getmedicinetypeList();
  }
};
</script>
